import React from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import { withConfig } from '@catalogo/core-connect/config';
import ProductGallery from '@catalogo/ui-americanas-mobile-product-gallery';
import { Rating } from '@catalogo/theme-rating-reviews';
import Breadcrumb from '@catalogo/theme-breadcrumb';
import Sku from '@catalogo/ui-americanas-mobile-sku';
import Share from '@catalogo/theme-share';
import Wishlist from '@catalogo/ui-americanas-mobile-wishlist';
import ProductDisclaimer from '@catalogo/ui-americanas-mobile-product-disclaimer';
import QnaAnchor from '../qna-anchor';
import ProductTitle from '../product-title';
import Badges from '../badges';
import AirConditionerInfo from './air-conditioner-info';

const ProductInfo = props => {
  const renderPreSale = () => {
    const { product } = props;
    const isPreSale = getIn(product, ['isPreSale']);
    const launchingAt = getIn(product, ['launchAt']);

    if (!isPreSale) {
      return null;
    }

    return (
      <PreSaleText>
        <strong>Pré-venda: </strong> lançamento em {launchingAt}
      </PreSaleText>
    );
  };

  const { product, page, currentSku, updateUrl, experiment, dispatchMetrics } = props;
  const rating = getIn(product, ['rating'], null);
  const breadcrumb = getIn(page, ['breadcrumb'], []) || [];

  const { name } = product || {};

  const configShare = {
    title: name,
    text: name,
  };

  return (
    <ProductMain>
      <Breadcrumb breadcrumb={breadcrumb} textLowerCase />
      <ButtonsTop>
        <WrapperIcons>
          <Wishlist sku={currentSku} product={product} hasBoxShadow={false} />
          <Share {...props} config={configShare} hasBoxShadow={false} />
        </WrapperIcons>
      </ButtonsTop>
      <ProductGallery {...props} quantity={4} />
      <WrapperMain>
        <ProductTitle {...props} />
        <WrapperRating>
          <Rating rating={rating} size={15} productId={product?.id} fontSize={11} dispatchMetrics={dispatchMetrics} />
          <QnaAnchor
            breadcrumb={breadcrumb}
            components={getIn(page, ['components'])}
            product={product}
            cache={true}
            currentSku={currentSku}
            isMobile={true}
          />
        </WrapperRating>
        <Badges currentSku={currentSku} product={product} />
        {renderPreSale()}
        <AirConditionerInfo product={product} />
        <ProductDisclaimer {...props} />
        <Sku {...props} experiment={experiment?.CAT_021_VARIACOES_SKU} updateUrl={updateUrl} />
      </WrapperMain>
    </ProductMain>
  );
};

const ContainerGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ButtonsTop = styled(ContainerGroup)`
  display: flex;
  justify-content: flex-end;
  height: 50px;
`;

const WrapperIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  margin-right: 10px;
`;

const WrapperMain = styled.div`
  margin: 15px 10px;
`;

const ProductMain = styled.div`
  background-color: #fff;
`;

const WrapperRating = styled.div`
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
`;

const PreSaleText = styled.p`
  font-size: 14px;
  padding: 0px 0 10px;
`;

export default withConfig(ProductInfo);
